import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

function StudentCard({
  isCorrect,
  TextValue,
  startListening,
  isTeacherTurn,
  isListening,
  transcript,
  similarityScore,
  getFeedbackMessage,
  getSimilarityColor,
  activeLevel,
}) {
  const [changeContent, setChangeContent] = useState("");
  const contentValue = useSelector((state) => state.contents.contentValues);

  const changeValue = (contentValue, activeLevel) => {
    let currentContent = "";
    if (contentValue.section === "reading" && activeLevel === "verbs") {
      currentContent = contentValue?.verbs?.[TextValue];
    }
    if (contentValue.section === "reading" && activeLevel === "Story") {
      currentContent = contentValue?.Articles?.Story;
    }
    if (contentValue.section === "vocabulary") {
      currentContent = contentValue?.contents?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "examples") {
      currentContent = contentValue?.examples?.[TextValue];
    }
    if (contentValue.section === "grammar" && activeLevel === "exercises") {
      currentContent = contentValue?.exercises?.[TextValue];
    }
    return currentContent;
  };

  // StudentCard bileşenine bir useEffect ekleyin
  useEffect(() => {
    // Teacher turn veya TextValue değiştiğinde transcript ve skoru temizle
    if (isTeacherTurn || !transcript) {
    }
  }, [isTeacherTurn, TextValue, activeLevel]);

  useEffect(() => {
    const returnvalue = changeValue(contentValue, activeLevel);
    if (returnvalue) {
      setChangeContent(returnvalue);
    } else {
      setChangeContent(""); // İçerik bulunamazsa state'i temizle
    }
  }, [activeLevel, contentValue, TextValue]); // Tüm bağımlılıkları ekle
  return (
    <div
      className={`${
        !isTeacherTurn ? "bg-yellow-500" : "bg-gray-200"
      } rounded-2xl p-4 md:p-6 shadow-xl border-l-4 ${
        !isTeacherTurn ? "border-purple-500" : "border-gray-400"
      } hover:shadow-2xl transition-all ${
        activeLevel === "Advanced" ? "md:col-span-2" : ""
      }  `}
    >
      <div
        className="flex flex-col sm:flex-row items-start 
          sm:items-center justify-between gap-3 mb-4 "
      >
        <div className="sm:flex  items-center gap-2 hidden">
          <span className="text-xl md:text-3xl">👨‍🎓</span>
          <div className="flex flex-col">
            <p
              className={`text-lg md:text-xl font-bold ${
                isTeacherTurn ? "text-gray-500 " : "text-gray-800"
              }`}
            >
              Student (You)
            </p>
            <hr className="border-b-2 border-purple-500" />
            <p>Öğrenci(siz)</p>
          </div>
        </div>
        <button
          onClick={startListening}
          disabled={isTeacherTurn || isListening}
          className={`px-6 py-3 font-semibold rounded-lg shadow-md
                 transition-all flex items-center gap-2 text-sm md:text-base
                  w-full sm:w-auto justify-center ${
                    !isTeacherTurn && !isListening
                      ? "bg-purple-500 hover:bg-purple-600 text-white"
                      : "bg-gray-400 text-gray-100 cursor-not-allowed"
                  }`}
        >
          <span className="text-3xl">🎤</span>
          <div className="flex flex-col">
            <p> {isListening ? "Listening..." : "Speak"}</p>
            <hr className="border-b-2 border-yellow-500" />
            <p className="text-sm font-normal">
              {isListening ? "konuşuluyor..." : "konuşma"}
            </p>
          </div>
        </button>
      </div>

      {transcript && (
        <div
          className={`mt-4 p-3 border-l-4 rounded-2xl ${
            isCorrect
              ? "bg-green-50 border-green-500"
              : "bg-yellow-50 border-yellow-500"
          }`}
        >
          <p
            className={`text-sm font-semibold ${
              isCorrect ? "text-green-700" : "text-yellow-700"
            }`}
          >
            {isCorrect ? "Doğru! 🎉 (Otomatik geçiliyor...)" : "You said:"}
          </p>
          <p className="text-gray-800">{transcript}</p>

          {/* Benzerlik skoru gösterimi */}
          {similarityScore > 0 && (
            <div className="mt-2 p-2 bg-blue-50 rounded-lg">
              <div className="flex justify-between items-center">
                {/* <span className="text-xs text-blue-700 font-medium">
                  Benzerlik Skoru:
                </span> */}
                <span
                  className={`text-sm font-bold ${getSimilarityColor(
                    similarityScore,
                  )}`}
                >
                  {(similarityScore * 100).toFixed(1)}%
                </span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                <div
                  className={`h-2 rounded-full ${
                    similarityScore >= 0.8
                      ? "bg-green-500"
                      : similarityScore >= 0.6
                        ? "bg-yellow-500"
                        : "bg-red-500"
                  }`}
                  style={{ width: `${similarityScore * 100}%` }}
                ></div>
              </div>
              {/* <p className="text-xs text-blue-600 mt-1">
                {getFeedbackMessage(similarityScore)}
              </p> */}
            </div>
          )}

          {!isCorrect && (
            <p className="text-xs text-gray-500 mt-1">
              Beklenen: {changeContent.Eng || changeContent}
            </p>
          )}
        </div>
      )}
    </div>
  );
}

export default StudentCard;
